import { sendHTTPRequest } from "@/util/http.ts";
import { goalbookUrls } from "@/util/links";
import type { GroupedStrategiesPayload } from "@/strategies/udlindex/udl_index_types"
import type { StrategySearchResponse, StrategySummary, StrategyTags } from "@/strategies/strategy_types"
const toolkitUrl = import.meta.env.VITE_TOOLKIT_URL

export async function getStrategyTags(params = {}): Promise<StrategyTags> {
  const options = new URLSearchParams(params)
  try {
    const response = await sendHTTPRequest({
      url: `${toolkitUrl}/api/strategy_tags?${options.toString()}`,
      method: 'GET',
      includeCredentials: true
    })
    return await response.json() as StrategyTags
  } catch (e) {
    throw new Error('Failed to get strategy tags', { cause: e })
  }
}

export async function getStrategiesGrouped(): Promise<GroupedStrategiesPayload> {
  try {
    const response = await sendHTTPRequest({
      url: `${toolkitUrl}/api/strategies/grouped`,
      method: 'GET',
      includeCredentials: true
    })
    return await response.json() as GroupedStrategiesPayload
  } catch (e) {
    throw new Error('Failed to get grouped strategies', { cause: e })
  }
}

export interface StrategySearchParams {
  tags?: string
  setting?: string
  teachingType?: string
  grades?: string
  query?: string
  size: number
}

export async function getStrategies(params: StrategySearchParams, signal?: AbortSignal): Promise<StrategySummary[]> {
  const options = new URLSearchParams({ published: 'true' })
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      options.set(key, String(value))
    }
  })

  try {
    const response = await sendHTTPRequest({
      url: `${goalbookUrls.pathwaysApi}/strategies/wizard?${options.toString()}`,
      method: 'GET',
      includeCredentials: true,
      signal
    })
    const payload = await response.json() as StrategySearchResponse
    return payload.hits.hits.map((hit) => hit._source)
  } catch (e) {
    // A superseded request aborts on purpose, so the caller has to be able to tell
    // that apart from a request that actually failed.
    if (signal?.aborted && e === signal.reason) {
      throw e
    }
    throw new Error('Failed to get strategies', { cause: e })
  }
}
